<template>
  <div class='zpDetail_con'>
    <div class='block1 pos_r'>
      <div class='bg'></div>
      <div class='info w_1200'>
        <h3>{{ detail.title }}</h3>
        <div class='addit cf'>
          <div class='fl'>
            <dl>
              <dt>地点</dt>
              <dd>{{ detail.city || '不限' }}</dd>
            </dl>
            <dl>
              <dt>部门</dt>
              <dd>{{ detail.department_id || '不限' }}</dd>
            </dl>
            <dl>
              <dt>学历</dt>
              <dd>{{ detail.education|| '不限' }}</dd>
            </dl>
            <dl>
              <dt>年限</dt>
              <dd>{{ detail.years|| '不限' }}</dd>
            </dl>
            <dl>
              <dt>招聘人数</dt>
              <dd>{{ detail.numbers|| '不限' }}</dd>
            </dl>
          </div>
          <div class='fr date'>{{ detail.date }}前发布</div>
        </div>
        <div class='text'>
          <p class='fw600'>工作职责：</p>
          <html-content :html='detail.content'></html-content>
          <p class='fw600'>工作要求：</p>
          <!-- <p>具有良好的审美能力，对年轻的、潮流的设计趋势有良好的理解与洞察；<br> 善于发挥视觉表现力与创意；<br> 有丰富的产品界面设计经验，对视觉设计有系统性的理解，具有担当主视觉风格的指导的能力；<br> 具有良好的沟通能力及团队协作能力，对设计工作保有激情与责任感；<br> 有手绘、动画、3d等设计能力者优先，有带团队经验者优先；<br> 应聘该岗位请务必提交作品集。</p> -->
        </div>
        <a href='mailto:amy@hbtown.com' class='more more2'>投递该职位</a>
      </div>
    </div>
  </div>
</template>

<script>
import { setTitle } from 'utils'
import { getJobsDetail } from '@/service'
import HtmlContent from '@/components/HtmlContent'

export default {
  name: 'Home',
  components: {
    HtmlContent,
  },
  data () {
    return {
      detail: {},
    }
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('about.joinUs.title')}`)
  },
  mounted () {
    let query = this.$route.query
    getJobsDetail(query.id).then(res => {
      this.detail = res.data
    })
  },
}
</script>
